import { usePaymentMode } from "@/hooks/usePaymentMode";
import { useGetCustomer } from "@/services/api";
import { isBusinessCustomer } from "@/utils/customerUtils";

/**
 * Only business customers paying by invoice manage Vertragskonten
 * (Rechnungsempfänger); private invoice customers keep the plain "Rechnung".
 */
export const useBillingAccountAccess = () => {
  const { isInvoice, isLoading: isLoadingPaymentMean } = usePaymentMode();
  const { data: customer, isPending: isLoadingCustomer } = useGetCustomer();

  return {
    hasBillingAccounts: isInvoice && !!customer && isBusinessCustomer(customer),
    isLoading: isLoadingPaymentMean || (isInvoice && isLoadingCustomer),
  };
};
